/**
 * Owner: Masa Bayu
 * File: id.ts
 * Date:Time: 2026-09-18 15:50
 * Description: Stable identity helpers for Document IR objects.
 */

export type QXDocumentId = string;

export function createQXDocumentId(prefix: string): QXDocumentId {
  return `${prefix}_${crypto.randomUUID()}`;
}
